const generateSpeakerName = (content) => {
  if (!content.fieldFirstNameWeb && !content.fieldLastNameWeb) {
    return content.label;
  } else {
    return `${content?.fieldTitle ? `${content?.fieldTitle} ` : ''}${content?.fieldFirstNameWeb ? content?.fieldFirstNameWeb : ''} ${content?.fieldLastNameWeb ? content?.fieldLastNameWeb : ''}`;
  }
};

export { generateSpeakerName };
